import { render, staticRenderFns } from "./RelatedPeopleStep.vue?vue&type=template&id=8e86649e"
import script from "./RelatedPeopleStep.vue?vue&type=script&lang=ts"
export * from "./RelatedPeopleStep.vue?vue&type=script&lang=ts"
import style0 from "./RelatedPeopleStep.vue?vue&type=style&index=0&id=8e86649e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports